/**
 * Access rules that are checked in more than one place in the UI.
 *
 * These MUST stay in sync with the backend middleware — the backend is the
 * real gate (see backend/src/middleware/auth.ts). Anything here is only about
 * not showing a user a door they can't walk through.
 */

/**
 * The controlling org ("Data Bodies HQ"). The Identity Graph is a GLOBAL view
 * of our owned-enrichment asset — it is deliberately NOT visible to any
 * customer org. Keep in sync with the backend HQ_ORG_ID / config.access.hqOrgId.
 * Override at build time with REACT_APP_HQ_ORG_ID.
 */
export const HQ_ORG_ID =
  import.meta.env.REACT_APP_HQ_ORG_ID || '813b4593-1057-4b0c-be2e-bf9c44e8f0fb';

/**
 * Identity Graph visibility: super_admins, PLUS org_admins who belong to the
 * HQ org. No other org's admins — and no plain `user` role, in any org.
 *
 * Mirrors requireIdentityGraphAccess() in backend/src/middleware/auth.ts.
 */
export function canSeeIdentityGraph(
  user?: { role?: string; orgId?: string | null } | null
): boolean {
  if (!user) {return false;}
  if (user.role === 'super_admin') {return true;}
  return user.role === 'org_admin' && user.orgId === HQ_ORG_ID;
}
